import React, { forwardRef } from 'react';

import Accordion from 'react-bootstrap/Accordion';

import whyus from './img/tech.png';

import './tech.scss';

interface TechProps {

}

const Tech = forwardRef<HTMLElement, TechProps>((props: TechProps, ref: React.ForwardedRef<HTMLElement>) => {

  return (
    <section ref={ref} className="component-tech section-bg">
      <div className="container-fluid" data-aos="fade-up">

        <div className="row">

          <div className="col-lg-7 d-flex flex-column justify-content-center align-items-stretch  order-2 order-lg-1">

            <div className="content">
              <h3>Solutions crafted by our engineers <strong>we love to make things!</strong></h3>
              <p>
                Technology is the tool, delivering the right solution is the focus.
              </p>
            </div>

            <Accordion defaultActiveKey="0">
              <Accordion.Item eventKey="0">
                <Accordion.Header><span><i className="bi bi-code-square"></i></span>Software &amp; Product Development<i className="bi bi-chevron-down icon-show"></i><i className="bi bi-chevron-up icon-close"></i></Accordion.Header>
                <Accordion.Body>
                  <p>
                    We build clean, resilient solutions that scale smoothly, lower technical debt, and give your business a dependable digital foundation.
                  </p>
                  <p>
                    Whether it's web platforms or mobile apps, we select the right languages and frameworks to balance performance, team maintainability, and time to market.
                  </p>
                  <ul>
                    <li><i className="bi bi-arrow-down-right-square"></i>React / Angular</li>
                    <li><i className="bi bi-arrow-down-right-square"></i>JavaScript / TypeScript</li>
                    <li><i className="bi bi-arrow-down-right-square"></i>Node.js</li>
                    <li><i className="bi bi-arrow-down-right-square"></i>PHP</li>
                    <li><i className="bi bi-arrow-down-right-square"></i>.NET</li>
                    <li><i className="bi bi-arrow-down-right-square"></i>Python</li>
                    <li><i className="bi bi-arrow-down-right-square"></i>React Native / Flutter</li>
                  </ul> 
                </Accordion.Body>
              </Accordion.Item>
              <Accordion.Item eventKey="1">
                <Accordion.Header><span><i className="bi bi-clouds"></i></span>Cloud &amp; Infrastructure<i className="bi bi-chevron-down icon-show"></i><i className="bi bi-chevron-up icon-close"></i></Accordion.Header>
                <Accordion.Body>
                  <p>
                    By leveraging Amazon Web Services (AWS), Google Cloud Platform (GCP) and Azure our cloud architectures focus on eliminating operational bottlenecks, reducing compute costs, and ensuring high availability for your core services.
                  </p>
                  <p>
                    We design environments tailored to your workload, with cloud setups that scale as your business grows.
                  </p>
                  <ul>
                    <li><i className="bi bi-arrow-down-right-square"></i>Compute instances and virtual machines.</li>
                    <li><i className="bi bi-arrow-down-right-square"></i>Containerisation with self or provider managed services.</li>
                    <li><i className="bi bi-arrow-down-right-square"></i>Serverless and event-driven compute engines.</li>
                    <li><i className="bi bi-arrow-down-right-square"></i>Fully managed relational or document databases.</li>
                  </ul>
                </Accordion.Body>
              </Accordion.Item>
              <Accordion.Item eventKey="2">
                <Accordion.Header><span><i className="bi bi-bezier2"></i></span>Operations &amp; Delivery<i className="bi bi-chevron-down icon-show"></i><i className="bi bi-chevron-up icon-close"></i></Accordion.Header>
                <Accordion.Body>
                  <p>
                    We remove friction from your product lifecycle so your team can release updates faster, safely, and with operational visibility. 
                  </p>
                  <p>
                    Introducing automated and repeatable processes helps us eliminate manual errors, mitigate release risks, and keep product momentum high.
                  </p>
                  <ul>
                    <li><i className="bi bi-arrow-down-right-square"></i>Infrastructure as Code (IaC) with Terraform or AWS CDK.</li>
                    <li><i className="bi bi-arrow-down-right-square"></i>Continuous integration and delivery using build and deploy pipelines.</li>
                    <li><i className="bi bi-arrow-down-right-square"></i>Logging, monitoring and alerting to react to failure or changing demand.</li>
                    <li><i className="bi bi-arrow-down-right-square"></i>Product lifecycle management in order to keep a lean process.</li>
                  </ul>
                </Accordion.Body>
              </Accordion.Item>
              <Accordion.Item eventKey="3">
                <Accordion.Header><span><i className="bi bi-robot"></i></span>Artificial Intelligence<i className="bi bi-chevron-down icon-show"></i><i className="bi bi-chevron-up icon-close"></i></Accordion.Header>
                <Accordion.Body>
                  <p>
                    We don't just add AI to your business or product for the sake of AI, we aim to cut through the hype and noise and treat it as a high-performing tool to complement your business.
                  </p>
                  <p>
                    Grounded in your specific industry context, we look to automate operational tasks while ensuring your underlying systems remain secure, maintainable, and audit-ready.
                  </p>
                  <ul>
                    <li><i className="bi bi-arrow-down-right-square"></i>Retrieval Augmented Generation (RAG), tailoring AI to understand your specific industry, documentation and customer needs.</li>
                    <li><i className="bi bi-arrow-down-right-square"></i>AI Agents, identifying high value workflows where autonomous agents can support your business.</li>
                    <li><i className="bi bi-arrow-down-right-square"></i>Reviewing and rewriting AI generated code and documentation to ensure it meets your needs and is maintainable in the long term.</li>
                  </ul>
                </Accordion.Body>
              </Accordion.Item>
            </Accordion>

          </div>

          <div className="col-lg-5 align-items-stretch order-1 order-lg-2 img" style={{backgroundImage: `url(${whyus})`}} data-aos="zoom-in" data-aos-delay="150">&nbsp;</div>
        </div>

      </div>
    </section>
  );
});

export default Tech;